export default "__VITE_ASSET__aRVPw_kR__"